import { useWsmDealerSettingsQuery, useWsmDealerSettingsUpdateMutation } from "@dashboard/graphql";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { getMutationState } from "@dashboard/misc";
import React from "react";
import { useIntl } from "react-intl";

import WsmDealerSettingsPage from "../components/WsmDealerSettingsPage/WsmDealerSettingsPage";

export const WsmDealerSettingsView = () => {
  const intl = useIntl();
  const notify = useNotifier();
  const { data, loading } = useWsmDealerSettingsQuery();
  const [updateSettings, updateSettingsOpts] = useWsmDealerSettingsUpdateMutation({
    onCompleted: result => {
      if (!result.wsmDealerSettingsUpdate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
      }
    },
  });
  const errors = updateSettingsOpts.data?.wsmDealerSettingsUpdate?.errors ?? [];
  // No row means the defaults, which the contract pins at stacking OFF.
  const discountStacking = data?.wsmDealerSettings?.discountStacking ?? false;

  return (
    <WsmDealerSettingsPage
      key={String(discountStacking)}
      initialData={{ discountStacking }}
      errors={errors}
      disabled={loading || updateSettingsOpts.loading}
      saveButtonBarState={getMutationState(
        updateSettingsOpts.called,
        updateSettingsOpts.loading,
        errors,
      )}
      onSubmit={values => updateSettings({ variables: { input: values } })}
    />
  );
};

export default WsmDealerSettingsView;
